import styled, { css } from 'styled-components';

const CheckboxIcon = styled.span(({ indeterminate, theme: { olist: { components: { checkbox }, }, }, }) => css `
    display: none;
    color: ${checkbox.checkmark.icon.color};
    box-sizing: border-box;

    ${indeterminate
    ? css `
          width: 10px;
          border: 1px solid;
          background-color: ${checkbox.checkmark.icon.color};
        `
    : css `
          transform: rotate(45deg);
          height: 10px;
          width: 6px;
          border-bottom: 2px solid;
          border-right: 2px solid;
          position: relative;
          top: -2px;
        `}
  `);

export { CheckboxIcon };
